import React from 'react';
import DataTableActionMenu from '../../../Elements/DataTable/DataTableActionMenu';
import LongText from '../../../Elements/LongText';
import UserNameComponent from '../../../Elements/UserNameComponent';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import InvoiceAutomationRunTriggerTypeEnum from '../../../Enums/InvoiceAutomationRunTriggerTypeEnum';
import InvoiceAutomationRunOutcomeBadge from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationRunOutcomeBadge.tsx';

// One run of a project's automatic invoicing, as its History lists it.
export default class InvoiceAutomationRunItem {
  constructor(item) {
    if (item === undefined) {
      this.InvoiceAutomationRunId = '';
      this.TriggerType = '';
      this.TriggeredByUserId = '';
      this.StartedOnUtc = '';
      this.FinishedOnUtc = '';
      this.Outcome = '';
      this.Message = '';
      this.DraftsCreated = '';
      this.JobsAdded = '';
      this.JobsSkipped = '';
      this.JobsRemoved = '';
      return;
    }

    this.InvoiceAutomationRunId = item.invoiceAutomationRunId;
    this.TriggerType = item.triggerType;
    this.TriggeredByUserId = item.triggeredByUserId;
    this.StartedOnUtc = item.startedOnUtc;
    this.FinishedOnUtc = item.finishedOnUtc;
    this.Outcome = item.outcome;
    this.Message = item.message ?? '';
    this.DraftsCreated = item.draftsCreated;
    this.JobsAdded = item.jobsAdded;
    this.JobsSkipped = item.jobsSkipped;
    // Taken off its drafts as no longer ready for invoicing.
    this.JobsRemoved = item.jobsRemoved ?? 0;
  }

  static NameOfTheIdField() {
    return 'InvoiceAutomationRunId';
  }

  static nameOfTheItemDetailList() {
    return 'Automatic Invoicing Run';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateOnlyFields = [];

  static DateFields = [];

  static BoolFields = [];

  // The start time opens the run's details, as its row action does.
  static getStartedOn(item) {
    return (
      <button
        type='button'
        className='link'
        onClick={() => InvoiceAutomationRunItem.openDetailFunction(item)}
      >
        {dateTimeHelper.utcToLocalYYYYsMMsDDsHHsMM(item.StartedOnUtc)}
      </button>
    );
  }

  // The morning run is started by the system user, whose name says nothing.
  static getStartedBy(item) {
    if (item.TriggerType === InvoiceAutomationRunTriggerTypeEnum.Daily) {
      return 'Morning run';
    }
    return <UserNameComponent userId={item.TriggeredByUserId} />;
  }

  static getOutcome(item) {
    return <InvoiceAutomationRunOutcomeBadge outcome={item.Outcome} />;
  }

  static getMessage(item) {
    return (
      <LongText
        text={item.Message}
        maxLength={60}
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-circle-info',
            text: 'View Details',
            onClick: () => InvoiceAutomationRunItem.openDetailFunction(item),
          },
        ]}
      />
    );
  }

  static openDetailFunction = (item) => {
    alert('Empty function');
  };

  static FieldsToShowInDataTable() {
    return [
      { label: 'Started', orderById: '', data: InvoiceAutomationRunItem.getStartedOn },
      { label: 'Started By', orderById: '', data: InvoiceAutomationRunItem.getStartedBy },
      { label: 'Result', orderById: '', data: InvoiceAutomationRunItem.getOutcome },
      { label: 'Drafts Created', orderById: '', data: 'DraftsCreated' },
      { label: 'Jobs Added', orderById: '', data: 'JobsAdded' },
      { label: 'Jobs Removed', orderById: '', data: 'JobsRemoved' },
      { label: 'Jobs Skipped', orderById: '', data: 'JobsSkipped' },
      { label: 'Message', orderById: '', data: InvoiceAutomationRunItem.getMessage },
      {
        label: ' ',
        orderById: '',
        data: InvoiceAutomationRunItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }
}
